import type { IconProps } from '@ab-core/icon';
import { Icon } from '@ab-core/icon';
import type { LinkProps } from '@ab-core/link';
import { Link } from '@ab-core/link';
import type { TextProps } from '@ab-core/text';
import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import { NotExistingContainer, NotExistingStroke } from './styled';

type AdditionalLinkProps = {
    exists?: boolean;
    to: LinkProps['to'];
    iconName: IconProps['name'];
    text: string;
};

export const AdditionalLink: FC<AdditionalLinkProps> = (props) => {
    const { exists = false, to, iconName, text } = props;
    const iconStyle: IconProps = {
        name: iconName
    };
    const textStyle: TextProps = {
        type: FontTypes.Body,
        color: exists ? 'primary' : 'gray30'
    };

    return (
        <Text {...textStyle}>
            {exists && (
                <Link to={to}>
                    <Icon {...iconStyle} />
                    {text}
                </Link>
            )}
            {!exists && (
                <NotExistingContainer>
                    <Icon {...iconStyle} />
                    <NotExistingStroke />
                </NotExistingContainer>
            )}
        </Text>
    );
};
